import { useEffect, useState } from 'react';
import openAudioEffect from '~/assets/mp3/open_nav.mp3';
import closeAudioEffect from '~/assets/mp3/close_nav.mp3';
import { useAudioEffect } from './useAudioEffect';

export function useOpenCloseAudioEffect(status?: boolean | null) {
  const [audioEffect, setAudioEffect] = useState(false);
  const [playOpenEffect] = useAudioEffect(openAudioEffect);
  const [playCloseEffect] = useAudioEffect(closeAudioEffect);

  const open = () => {
    try {
      playOpenEffect();
    } catch (error) {
      // Silently ignore audio effect errors
    }
  };
  const close = () => {
    try {
      playCloseEffect();
    } catch (error) {
      // Silently ignore audio effect errors
    }
  };

  useEffect(() => {
    if (audioEffect) {
      status ? open() : close();
    } else {
      setAudioEffect(true);
    }
  }, [status]);

  return [open, close];
}
